(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["experience-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('experience-video-hero')) {
    customElements.define('experience-video-hero', class extends HTMLElement {
      connectedCallback() {
        this.videoSlot = this.querySelector('[data-video-slot]');
        this.motionButton = this.querySelector('.experience-video-hero__motion');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileViewport = window.matchMedia(`(max-width: ${this.dataset.breakpoint}px)`);
        this.saveData = navigator.connection && navigator.connection.saveData;
        this.slowConnection = navigator.connection && /(^|-)2g$/.test(navigator.connection.effectiveType || '');

        if (!this.videoSlot || this.reducedMotion.matches || this.saveData || this.slowConnection) return;

        const loadVideo = () => {
          const sourceData = this.mobileViewport.matches
            ? this.querySelector('[data-mobile-sources]')
            : this.querySelector('[data-desktop-sources]');
          if (!sourceData || this.activeVideo) return;

          try {
            this.sources = JSON.parse(sourceData.textContent);
          } catch (error) {
            return;
          }
          if (!Array.isArray(this.sources) || !this.sources.length) return;

          this.activeSegment = 0;
          this.activeVideo = this.createVideo(this.sources[0], true);
          this.bufferVideo = this.createVideo(this.sources[1] || this.sources[0], false);
          this.videoSlot.append(this.activeVideo, this.bufferVideo);
          this.motionButton.addEventListener('click', () => this.togglePlayback());
          this.activeVideo.addEventListener('playing', () => this.classList.add('is-video-ready'), { once: true });
          this.activeVideo.addEventListener('loadedmetadata', () => {
            const requestedStart = Number(this.dataset.initialStart) || 0;
            this.activeVideo.currentTime = Math.min(requestedStart, Math.max(0, this.activeVideo.duration - 0.05));
          }, { once: true });
          this.activeVideo.addEventListener('seeked', () => {
            this.motionButton.hidden = false;
            this.activeVideo.play().catch(() => {
              this.motionButton.hidden = true;
            });
          }, { once: true });
          this.activeVideo.load();
          this.bufferVideo.load();
        };

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(loadVideo, { timeout: 1200 });
        } else {
          window.addEventListener('load', loadVideo, { once: true });
        }
      }

      createVideo(source, isActive) {
        const video = document.createElement('video');
        video.className = `experience-video-hero__video${isActive ? ' is-active' : ''}`;
        video.src = source;
        video.muted = true;
        video.playsInline = true;
        video.preload = isActive ? 'metadata' : 'auto';
        video.setAttribute('aria-hidden', 'true');
        video.addEventListener('ended', () => {
          if (video === this.activeVideo) this.advanceSegment();
        });
        return video;
      }

      advanceSegment() {
        const previousVideo = this.activeVideo;
        const nextVideo = this.bufferVideo;
        this.activeSegment = (this.activeSegment + 1) % this.sources.length;
        nextVideo.currentTime = 0;
        nextVideo.classList.add('is-active');
        previousVideo.classList.remove('is-active');
        this.activeVideo = nextVideo;
        this.bufferVideo = previousVideo;
        this.activeVideo.play().catch(() => {});

        const followingSegment = (this.activeSegment + 1) % this.sources.length;
        this.bufferVideo.pause();
        this.bufferVideo.src = this.sources[followingSegment];
        this.bufferVideo.preload = 'auto';
        this.bufferVideo.load();
      }

      togglePlayback() {
        if (this.activeVideo.paused) {
          this.activeVideo.play();
          this.classList.remove('is-paused');
          this.motionButton.setAttribute('aria-label', this.dataset.pauseLabel);
        } else {
          this.activeVideo.pause();
          this.classList.add('is-paused');
          this.motionButton.setAttribute('aria-label', this.dataset.playLabel);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('experience-banner-video')) {
    customElements.define('experience-banner-video', class extends HTMLElement {
      connectedCallback() {
        const mediaWrapper = this.closest('.hero__media');
        const mobileViewport = window.matchMedia('(max-width: 749px)').matches;
        const isDesktopOnly = mediaWrapper && mediaWrapper.classList.contains('small-hide');
        const isMobileOnly = mediaWrapper && mediaWrapper.classList.contains('small-up-hide');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const connection = navigator.connection;

        if ((isDesktopOnly && mobileViewport) || (isMobileOnly && !mobileViewport)) return;
        if (reducedMotion || (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || '')))) return;

        this.videoSlot = this.querySelector('[data-video-slot]');
        const sourceData = this.querySelector('[data-video-sources]');
        if (!this.videoSlot || !sourceData) return;

        try {
          this.sources = JSON.parse(sourceData.textContent);
        } catch (error) {
          return;
        }
        if (!Array.isArray(this.sources) || !this.sources.length) return;

        const loadVideo = () => {
          if (this.activeVideo) return;
          this.activeSegment = 0;
          this.activeVideo = this.createVideo(this.sources[0], true);
          this.bufferVideo = this.createVideo(this.sources[1] || this.sources[0], false);
          this.videoSlot.append(this.activeVideo, this.bufferVideo);

          this.activeVideo.addEventListener('playing', () => this.classList.add('is-video-ready'), { once: true });
          this.activeVideo.addEventListener('loadedmetadata', () => {
            const requestedStart = Number(this.dataset.initialStart) || 0;
            this.activeVideo.currentTime = Math.min(requestedStart, Math.max(0, this.activeVideo.duration - 0.05));
          }, { once: true });
          this.activeVideo.addEventListener('seeked', () => {
            this.activeVideo.play().catch(() => {});
          }, { once: true });
          this.activeVideo.load();
          this.bufferVideo.load();
        };

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(loadVideo, { timeout: 1200 });
        } else {
          window.addEventListener('load', loadVideo, { once: true });
        }
      }

      createVideo(source, isActive) {
        const video = document.createElement('video');
        video.className = `hero__experience-video-player${isActive ? ' is-active' : ''}`;
        video.src = source;
        video.muted = true;
        video.playsInline = true;
        video.preload = isActive ? 'metadata' : 'auto';
        video.setAttribute('aria-hidden', 'true');
        video.addEventListener('ended', () => {
          if (video === this.activeVideo) this.advanceSegment();
        });
        return video;
      }

      advanceSegment() {
        const previousVideo = this.activeVideo;
        const nextVideo = this.bufferVideo;
        this.activeSegment = (this.activeSegment + 1) % this.sources.length;
        nextVideo.currentTime = 0;
        nextVideo.classList.add('is-active');
        previousVideo.classList.remove('is-active');
        this.activeVideo = nextVideo;
        this.bufferVideo = previousVideo;
        this.activeVideo.play().catch(() => {});

        const followingSegment = (this.activeSegment + 1) % this.sources.length;
        this.bufferVideo.pause();
        this.bufferVideo.src = this.sources[followingSegment];
        this.bufferVideo.preload = 'auto';
        this.bufferVideo.load();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pukara-bookings"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pukara-booking-request')) {
    class PukaraBookingRequest extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('form');
        const success = this.querySelector('[data-booking-success]');
        if (success) { success.focus(); return; }
        if (!form) return;
        const date = form.querySelector('[data-booking-date]');
        const today = new Intl.DateTimeFormat('en-CA', {timeZone:'Australia/Sydney',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
        const part = key => today.find(value => value.type === key).value;
        date.min = `${part('year')}-${part('month')}-${part('day')}`;
        form.addEventListener('submit', event => {
          if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
          const summary = form.querySelector('[data-booking-summary]');
          const fields = Array.from(form.querySelectorAll('[data-booking-field]')).map(field => {
            const label = field.labels?.[0]?.textContent.trim() || field.name;
            let value = field.value.trim();
            if (field === date && value) { const [year,month,day] = value.split('-'); value = `${day}/${month}/${year}`; }
            return value ? `${label}: ${value}` : '';
          }).filter(Boolean);
          summary.value = `${summary.defaultValue}\n\n${fields.join('\n')}`;
        });
      }
    }
    customElements.define('pukara-booking-request', PukaraBookingRequest);
  }

  } catch(e) { console.error(e); }
})();
})();
